import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

const routeChangeCallbacks = new Set<() => void>();

const notifyRouteChange = () => {
  routeChangeCallbacks.forEach(callback => {
    try {
      callback();
    } catch (error) {
      // Make sure the callback will not break the app
      console.error("Error in route change callback:", error);
    }
  });
};

export function useRouteChangeEffect(callback: () => void) {
  const location = useLocation();
  const prevPathnameRef = useRef<string>(location.pathname);

  useEffect(() => {
    routeChangeCallbacks.add(callback);
    return () => {
      routeChangeCallbacks.delete(callback);
    };
  }, [callback]);

  useEffect(() => {
    // Only run if it's not the first render and the path actually changed
    if (prevPathnameRef.current !== location.pathname) {
      // Schedule the callback as a microtask to avoid race conditions with React rendering
      setTimeout(() => {
        notifyRouteChange();
      }, 100);
    }

    prevPathnameRef.current = location.pathname;
  }, [location.pathname]);
}
